namespace GeniuzPOS.PosShift {
    export class PsEndDayCashierColumns {
        static columnsKey = 'PosShift.PsEndDayCashier';
    }
}
